import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EnvironmentSettingsService } from 'shared/services/environment-settings.service';
import { MultimodalService } from 'shared/services/multimodal.service';

type AlertType = { type: string; msg: string; timeout: number };


@Component({
  selector: 'app-system-admin-dashboard',
  templateUrl: './system-admin-dashboard.component.html',
  styleUrls: ['./system-admin-dashboard.component.scss']
})
export class SystemAdminDashboardComponent implements OnInit {

  alerts: AlertType[] = [];
  reportingForm!: UntypedFormGroup;
  isGeneratingReport = false;

  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private environmentSettingsService: EnvironmentSettingsService,
    private multimodalService: MultimodalService
  ) { }

  ngOnInit(): void {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);
    this.reportingForm = this.fb.group({ date: [[sevenDaysAgo, today]] });
  }

  triggerPartnerSync() {
    this.http.get(`${this.getBaserUrl()}/sync1141`, { responseType: 'text' })
    .subscribe({
      next: (response) => {
        this.alerts.push({
          type: 'success',
          msg: `Partner Sync was triggered succesfully!`,
          timeout: 5000
        });
        console.log('Success:', response);
      },
      error: (error) => {
        this.alerts.push({
          type: 'danger',
          msg: `Failed to trigger Partner Sync!`,
          timeout: 5000
        });
        console.error('Error:', error);
      }
    });
  }

  triggerSyncProductConfigurationMap() {
    this.http.get(`${this.getBaserUrl()}/sync1151`, { responseType: 'text' })
    .subscribe({
      next: (response) => {
        this.alerts.push({
          type: 'success',
          msg: `Sync EANs/Article Numbers was triggered succesfully!`,
          timeout: 5000
        });
        console.log('Success:', response);
      },
      error: (error) => {
        this.alerts.push({
          type: 'danger',
          msg: `Failed to trigger EANs/Article Numbers Sync!`,
          timeout: 5000
        });
        console.error('Error:', error);
      }
    });
  }

  onClosed(dismissedAlert: AlertType): void {
    this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
  }

  deleteAccount(): void {
    this.multimodalService.show('deleteAccount', 'form', false);
  }

  createSuperAdmin(): void {
    this.multimodalService.show('createSuperAdmin', 'form', false);
  }

  createReport(): void {
    const date: Date[] | null = this.reportingForm.value.date;
    const baseUrl = this.getBaserUrl();
    const params: Record<string, string> = {};
    if (date?.[0]) params['from'] = new Date(date[0]).toISOString();
    if (date?.[1]) params['to'] = new Date(date[1]).toISOString();
    const queryString = new URLSearchParams(params).toString();
    const url = `${baseUrl}/usage-report${queryString ? '?' + queryString : ''}`;

    this.isGeneratingReport = true;
    this.http.get(url, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        this.isGeneratingReport = false;
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        const fromDate = date?.[0] ? new Date(date[0]).toISOString().split('T')[0] : 'start';
        const toDate = date?.[1] ? new Date(date[1]).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
        a.download = `usage-report-${fromDate}_${toDate}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(objectUrl);
      },
      error: () => {
        this.isGeneratingReport = false;
        this.alerts.push({ type: 'danger', msg: 'Failed to generate business report!', timeout: 5000 });
      }
    });
  }

  private getBaserUrl() {
    return this.environmentSettingsService.settings.gatewayApiUrl.replace('/graphql', '');
  }

}
